@if (configuration?.image) {
    <div class="inline">
        @if (lazy) {
            <div class="inline">
                <app-lazy-asset-lazy
                    [configuration]="configuration"
                    [additionalClasses]="additionalClasses"
                    [lazy]="lazy"></app-lazy-asset-lazy>
            </div>
        } @else {
            <img
                class="w-full"
                [ngClass]="additionalClasses"
                [src]="defaultSrc || ''"
                [alt]="altText" />
        }
    </div>
}
